import React from "react";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import {
  clearClientSession,
  encrypt,
  setSessionTimerCookies,
  getParentDomain,
  COOKIE_OPTS,
} from "../../../config/cookieUtils";

class SSOCookieSetter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      successMessage: "",
      errorMessage: "",
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedData = urlParams.get("data");

    if (!encryptedData) {
      this.setState({ errorMessage: "Missing SSO data." });
      return;
    }

    try {
      const jsonStr = atob(encryptedData);
      const decrypted = JSON.parse(jsonStr);
      const selectedMenu = (decrypted.selected_menu || "").toLowerCase();

      // console.log("✅ Decrypted SSO Token:", decrypted);

      // Clear existing session cookies reliably (path + parent domain)
      console.info("[SSO] sso_cookies: Clearing previous client session");
      clearClientSession();

      // Set identity cookies with explicit path
      Cookies.set("client_name__", encrypt(decrypted.name), COOKIE_OPTS);
      Cookies.set("client_tkn__", encrypt(decrypted.token), COOKIE_OPTS);
      Cookies.set("client_acn__", encrypt(decrypted.accountno), COOKIE_OPTS);
      Cookies.set("client_eml__", encrypt(decrypted.email), COOKIE_OPTS);
      Cookies.set("client_comp_nme__", encrypt(decrypted.comp_name), COOKIE_OPTS);
      Cookies.set("client_title__", encrypt(decrypted.title), COOKIE_OPTS);
      Cookies.set("client_phone__", encrypt(decrypted.phone), COOKIE_OPTS);
      Cookies.set("client_adress__", encrypt(decrypted.address), COOKIE_OPTS);
      Cookies.set("client_country__", encrypt(decrypted.country), COOKIE_OPTS);
      Cookies.set("client_user_type__", encrypt(decrypted.user_type), COOKIE_OPTS);
      Cookies.set("client_parent_accountno__", encrypt(decrypted.parent_accountno), COOKIE_OPTS);
      Cookies.set("residentifier__", encrypt(decrypted.reseller_domain_identifier), COOKIE_OPTS);
      Cookies.set("reslogo__", encrypt(decrypted.reseller_logo), COOKIE_OPTS);
      Cookies.set("restkn__", encrypt(decrypted.reseller_hash), COOKIE_OPTS);
      Cookies.set("resacct__", encrypt(decrypted.reseller_accountno), COOKIE_OPTS);
      Cookies.set("filer_id__", encrypt(decrypted.filer_id), COOKIE_OPTS);
      Cookies.set("client_domain_name__", encrypt(decrypted.domain_name), COOKIE_OPTS);

      // Set session timer cookies (4h default, or use provided expiry)
      const tokenExpiryMs = decrypted.token_expiry || null;
      setSessionTimerCookies(tokenExpiryMs);
      console.info("[SSO] sso_cookies: Session timer cookies set");

      // Track SSO handshake for logout flow
      localStorage.setItem("client_sso_handshake", "Yes");

      // Cross-subdomain session indicator
      try {
        const _parentDomain = getParentDomain();
        if (_parentDomain) {
          Cookies.set('client_sl_session__', '1', { path: '/', domain: _parentDomain, expires: 1 });
        }
      } catch (_e) {}

      // console.log("✅ All SSO cookies set.");

      this.setState({
        successMessage: "Account authenticated successfully. Redirecting...",
      });

      let redirectPath = "/dashboard";

      switch (selectedMenu) {
        case "clients":
          redirectPath = "/SubClients";
          break;
        case "forms":
          redirectPath = "/forms";
          break;
        case "orders":
          redirectPath = "/SalesOrders";
          break;
        case "agreements":
          redirectPath = "/agreements";
          break;
        case "quotations":
          redirectPath = "/Quotations";
          break;
        case "credit application":
          redirectPath = "/CreditApp";
          break;
        case "reports":
          redirectPath = "/MetabaseReports";
          break;
        case "documents":
          redirectPath = "/documents";
          break;
        case "products & services":
          redirectPath = "/services";
          break;
        case "support":
          redirectPath = "/help";
          break;
        case "dashboard":
        default:
          redirectPath = "/dashboard";
          break;
      }

      setTimeout(() => {
        window.location.replace(
          `${window.location.origin}/${decrypted.reseller_domain_identifier}/client${redirectPath}`
        );
      }, 1500);
    } catch (err) {
      console.error("❌ Cookie set failed:", err);
      this.setState({ errorMessage: "Invalid SSO token. Please login again." });
      setTimeout(() => {
        window.location.replace("/login");
      }, 2000);
    }
  }

  render() {
    const { successMessage, errorMessage } = this.state;

    return (
      <div className="nk-content">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* Error Alert */}
              {errorMessage !== "" && (
                <div className="example-alert">
                  <div className="alert alert-pro alert-danger">
                    <div className="alert-text">
                      <h4>Error</h4>
                      <p>{errorMessage}</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Success Alert */}
              {successMessage !== "" && (
                <div className="example-alert">
                  <div className="alert alert-pro alert-success">
                    <div className="alert-text">
                      <h4>Success</h4>
                      <p>{successMessage}</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Spinner */}
              <div className="text-center" style={{ marginTop: "20%" }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SSOCookieSetter;
